define('drops/qrCode/qrCode',[
    'jquery',
    'lq',
    'lq/drop'
], function ($, lq, Drop) {
    'use strict';

    var defaults = {
        data: {
            contentType: 'applicationUrl',
            content: {}
        }
    };

    function QrCode(options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.$element
	        .addClass('boxToBorderSize')
            .css({
                'background-repeat': 'no-repeat',
                'background-size': 'contain'
            });
    };

    Drop.extend(QrCode, Drop);

    QrCode.typeName = 'QrCode';

    QrCode.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.setImage(this.getImageUrl());
    };

    QrCode.prototype.setImage = function (url) {
        this.$element.css('background-image', 'url(' + url + ')');
    };

    QrCode.prototype.getImageUrl = function () {
        return lq.getTenantUrl('GeneratedContent/QrCode/'
            + '?actionId=' + this.rootDrop.data.id
            + '&qrCodeId=' + this.data.id
            + '&parameters=' + encodeURIComponent(JSON.stringify(this.piping.parameters.getNonSystemParameters()))
            + '&width=' + this.data.size.x
            + '&height=' + this.data.size.y);
    };

    return QrCode;
});
